export default function convertCameraValuesToNumbers(obj) {
  const newObj = {}
  for (let [key, value] of Object.entries(obj)) {
    if (key === 'active' ||
        key === 'fovMode' ||
        key === 'unitOfMeasurement' ||
        key === 'name' ||
        key === 'notes' ||
        key === 'locked' ||
        key === 'location' ||
        key === 'backgroundPosition' ||
        key === 'backgroundSize' ||
        key === 'sceneName' ||
        key === 'streetViewUrl' ||
        key === 'streetViewActive' ||
        key === 'streetViewAvailable' ||
        key === 'userUploadedSceneUrl' ||
        key === 'userUploadedSceneActive' ||
        key === 'userSelectedGeneralScene' ||
        key === 'ppfHoverPosition' ||
        key === 'newlyAdded' ||
        key === 'model' ||
        key === 'displayIrLine' ||
        key === 'ppfNightMode' ||
        key === 'userSelectedPpfNightMode' ||
        key === 'dragged' ||
        key === 'color' ||
        key === 'isMultiImager' ||
        key === 'isFixedImager' ||
        key === 'isPtzImager') {
      continue
    }

    if (key === 'lensIds' || key === 'fixedLensIds') {
      newObj[key] = value.map(id => parseFloat(id)).filter(id => !isNaN(id))
    } else {
      newObj[key] = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
    }
  }
  return { ...obj, ...newObj }
}



// WEBPACK FOOTER //
// ./src/helpers/convertCameraValuesToNumbers.js